import React from 'react'
import styles from './SizeGuide.module.scss'
import useMatchMedia from '../../../hooks/matchMedia'
import useSizeGuide from '../../../hooks/sizeGuide/sizeGuide'
import Asset from '../../Asset'
import FormattedMessage from '../../FormattedMessage'
import SizeGuideTable from '../../SizeGuide/SizeGuideTable/SizeGuideTable'

type Props = {
  panelId: string
  presetId: number
  classes?: {
    root?: string
  }
}

const SizeGuide = (props: Props) => {
  const { presetId, panelId, classes } = props
  const { isDesktop, isTablet } = useMatchMedia()
  const sizeGuide = useSizeGuide()

  if (!presetId) {
    return null
  }

  const preset = sizeGuide.getPresetById(presetId)
  if (!preset) {
    return null
  }

  const sizesForType = sizeGuide.getSizesByPresetLabel(preset.label)
  // eslint-disable-next-line no-nested-ternary
  const columnCount = isDesktop ? 8 : isTablet ? 5 : 3
  const image = sizeGuide.getPresetImageByPresetLabel(preset.label)

  return (
    <div className={classes?.root!} id={panelId}>
      {isDesktop ? (
        <h2 className={styles['size-guide__heading']}>
          <FormattedMessage
            id="Product.Label.PanelSizeTitle"
            description="Product.Label.PanelSizeTitle"
            defaultMessage="Let's Size You Up"
          />
        </h2>
      ) : null}

      <div className={styles['size-guide__content']}>
        {image && isDesktop && (
          <div className={styles['size-guide__image-container']}>
            <Asset
              type="img"
              file={image}
              classes={styles['image-container__image']}
              withoutTheme
              alt="Size Guide"
              width={273}
              height={545}
            />
          </div>
        )}
        <SizeGuideTable preset={preset} sizes={sizesForType} columnCount={columnCount} />
      </div>
    </div>
  )
}

export default SizeGuide
